import React from 'react'
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import i18n from '../../../i18n';
import useQuery from '../../../useQuery';
import {FormattedMessage} from 'react-intl';
import {ButtonIcon} from '../../../components/button-icon/button-icon.component';
import CartMinusCircle from '../../../assets/icons/cart-minus-circle.svg';
import CartAddCircle from '../../../assets/icons/cart-add-circle.svg';
import getTagValue from '../../../utilities/get-tag-value';
import Currency from '../../../components/currency/currency';
import Trash03Icon from '../../../assets/icons0/trash-03.svg';
import {format} from 'date-fns';
import './order-item.scss';
import classnames from 'classnames';

const WarpOrderItem = ({endpointId, serviceById, decrementEndpoint, incrementEndpoint, cartEntry, deleteEndpoint, maxQuantity = 100000, endpointAvailable = true}) => {
    const {locale = 'uk'} = useQuery();
    const {endpointById} = useLazyLoadQuery(
        graphql`
            query orderItemEndpointByIdQuery($endpointId: String) {
                endpointById(id: $endpointId) {
                    id
                    name
                    price
                    nameUk
                    tags
                    labels
                }
            }
        `,
        {endpointId: endpointId}
    );
    const targetDate = getTagValue(endpointById.tags, 'targetDate');
    const isStem = endpointById.labels && endpointById.labels.isStem;
    const perOrderMax = parseInt(endpointById.labels?.maxPerOrder) || null;
    const effectiveMax = perOrderMax ? Math.min(maxQuantity, perOrderMax) : maxQuantity;
    const serviceTargetDate = serviceById.target ? format(new Date(serviceById.target), 'dd.MM.yyyy') : null;
    return (
        <div className='warp-order-item padding-top-1rem padding-bottom-2rem background-color-white border-bottom-1px-solid border-color-gray-200'>
            <div className='display-flex column-gap-0dot5rem align-items-center'>
                <p className={classnames('text-md mw768-text-lg flex-1', {'color-gray-700': endpointAvailable, 'color-gray-400': !endpointAvailable})}>
                    {i18n(serviceById, 'name', locale)} | <span className='white-space-nowrap'>{i18n(endpointById, 'name', locale)}</span>
                </p>
                <ButtonIcon {...{color: 'primary-gray', clickHandler: () => deleteEndpoint(cartEntry)}}>
                    <Trash03Icon className='warp-order-item__actions-svg'/>
                </ButtonIcon>
            </div>
            {targetDate ? 
                <p className={classnames('text-sm padding-top-0dot25rem', {'color-gray-500': endpointAvailable, 'color-gray-300': !endpointAvailable})}>{targetDate}</p>
                :
                serviceTargetDate && <p className={classnames('text-sm padding-top-0dot25rem', {'color-gray-500': endpointAvailable, 'color-gray-300': !endpointAvailable})}>{serviceTargetDate}</p>
            }
            <div className='padding-top-0dot5rem padding-bottom-1rem display-flex align-items-center justify-content-space-between'>
                <div className='display-flex align-items-center'>
                    <div className='display-flex align-items-center'>
                        <ButtonIcon {...{color: 'primary', clickHandler: () => decrementEndpoint(cartEntry), disabled: !endpointAvailable}}>
                            <CartMinusCircle className='warp-order-item__actions-svg'/>
                        </ButtonIcon>
                        <p className={classnames('margin-left-0dot5rem margin-right-0dot5rem min-width-2rem text-align-center display-inline-block text-md medium', {'color-primary-600': endpointAvailable, 'color-gray-300': !endpointAvailable})}>{cartEntry.quantity}</p>
                        <ButtonIcon {...{color: 'primary', clickHandler: () => incrementEndpoint(cartEntry), disabled: !endpointAvailable || effectiveMax <= cartEntry.quantity}}>
                            <CartAddCircle className='warp-order-item__actions-svg'/>
                        </ButtonIcon>
                    </div>
                </div>
                <p className={classnames('text-md medium mw768-text-lg display-flex align-items-center', {'color-gray-900': endpointAvailable, 'color-gray-300': !endpointAvailable})}>
                    <span className='padding-right-0dot125rem'>{endpointById.price.toFixed(2)}</span>
                    <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem, stemIconClasses: 'display-block width-1dot25rem height-1dot25rem'}}/>
                </p>
            </div>
        </div>
    )
};

export default React.memo(WarpOrderItem);